module.exports = __webpack_public_path__ + "img/歐盟標準_03.d0525d31.png";